module.exports = __webpack_public_path__ + "img/4.f53fb826.png";